import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Init from './Init';
import Launcher, { type iProps } from 'common/app/Launcher';
import Loading from 'common/components/Loading';
import { useWatermark } from 'pc-sales/pages/hooks/useWaterMark';
import { type ICookieUserInfo } from '../../../../types/auth';

interface Props {
    user: ICookieUserInfo;
    config: iProps;
}

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach(async (reg) => await reg.unregister());
    });

    if ('caches' in window) {
        caches.keys().then((names) => {
            names.forEach(async (name) => await caches.delete(name));
        });
    }
}

// 已登录入口
const App: React.FC<any> = (props: Props) => {
    const { config, user: userInfo } = props;
    useWatermark({ userInfo });
    return <Router>{config ? <Launcher {...config} /> : <Loading />}</Router>;
};

export default Init(App);
